// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"ba0306d1","821":"a4afff1c","977":"8591a78c"}[chunkId] + ".chunk.js";
};